import React, { useEffect, useState } from 'react';
import { useTeamRegistrationStore } from '../../../store/teamRegistrationStore';
import { useReportStore } from '../../../store/reportStore';

const PdfInfoBanner: React.FC = () => {
    const editId = useTeamRegistrationStore((state) => state.editId);
    const pdfUrl = useTeamRegistrationStore((state) => state.pdfUrl);
    const [showOverlay, setShowOverlay] = useState(true);
    const [showBanner, setShowBanner] = useState(true);
    const report = useReportStore((state) => state.report);

    if (!editId) return null;

    useEffect(() => {
        const timeoutId = setTimeout(() => {
            setShowOverlay(false);
        }, 2000);
        return () => clearTimeout(timeoutId);
    }, []);

    return (
        <>
            {showBanner && (
                <>
                    <div onClick={() => setShowOverlay(false)} className={`fixed inset-0 bg-black/20 z-40 transition-opacity duration-500 ${showOverlay ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} />
                    <div className={`relative ${showOverlay ? 'z-50' : 'z-10'} bg-yellow-50 flex-wrap flex justify-between items-center gap-3 border border-yellow-200 rounded-lg p-4`}>
                        <button
                            type="button"
                            className="absolute top-2 right-2 text-xs text-gray-500 hover:text-gray-700"
                            onClick={() => setShowBanner(false)}
                        >
                            Schließen
                        </button>
                        <div className='flex flex-wrap items-center gap-3'>
                            <div className="w-12 h-6 bg-gradient-to-r from-red-500/100 to-red-400 border border-red-500/20 rounded-sm shadow-md shadow-red-500/20 flex items-center justify-center">
                                <span className="text-white font-bold text-sm">PDF</span>
                            </div>
                            <div className='grid gap-1'>
                                <div className='text-sm font-medium'>Bitte prüfen Sie nochmals die Anzahl der gemeldeten Mannschaften:</div>
                                <div className='text-xs text-gray-500'>
                                    Sie haben bereits ein Team registriert und können auf Ihre PDF-Datei zugreifen. - Sie haben bereits eine Mannschaftsmeldung eingereicht und können die Meldung als PDF herunterladen. Sie können außerdem noch bis zum <span className="font-semibold text-gray-600">{report?.datumBis}</span> eine neue Mannschaftsmeldung einreichen und damit die bisherige Meldung ersetzen.
                                </div>
                            </div>
                        </div>
                        <div>
                            <a href={pdfUrl || ''} target="_blank" rel="noopener noreferrer" className="text-[#52A445] underline flex items-center gap-1 hover:text-blue-700">
                                <span className="font-bold">PDF ansehen</span>
                            </a>
                        </div>


                        {showOverlay && (
                            <div className="h-[5px] absolute -bottom-1.5 left-2 right-2 rounded-b-full overflow-hidden">
                                <div className="moving-diagonal-2 h-full w-full"></div>
                            </div>
                        )}
                    </div>
                </>
            )}

        </>
    );
};

export default PdfInfoBanner;


